import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_InertiaLink = _resolveComponent("InertiaLink")!
  const _component_ElDivider = _resolveComponent("ElDivider")!
  const _component_ElInput = _resolveComponent("ElInput")!
  const _component_ElFormItem = _resolveComponent("ElFormItem")!
  const _component_ElButton = _resolveComponent("ElButton")!
  const _component_ElForm = _resolveComponent("ElForm")!
  const _component_ElCard = _resolveComponent("ElCard")!
  const _component_AclLayout = _resolveComponent("AclLayout")!

  return (_openBlock(), _createBlock(_component_AclLayout, null, {
    default: _withCtx(() => [
      _createVNode(_component_ElCard, null, {
        default: _withCtx(() => [
          _createVNode(_component_InertiaLink, {
            href: "/admin/dynamic_services",
            class: "block w-full mb-3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                size: "small",
                class: "w-full"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Вернуться назад")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ElDivider),
          _createVNode(_component_ElForm, {
            onSubmit: _withModifiers(_ctx.submit, ["prevent"])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ElFormItem, {
                label: "Название сервиса",
                error: _ctx.errors.title,
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ElInput, {
                    modelValue: _ctx.form.title,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.title) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["error"]),
              _createVNode(_component_ElFormItem, {
                label: "Разрешение",
                error: _ctx.errors.permission,
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ElInput, {
                    modelValue: _ctx.form.permission,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.permission) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["error"]),
              _createVNode(_component_ElFormItem, {
                label: "URL",
                error: _ctx.errors.url,
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ElInput, {
                    modelValue: _ctx.form.url,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.url) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["error"]),
              _createVNode(_component_ElFormItem, {
                label: "Ссылка на иконку",
                error: _ctx.errors.iconUrl
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ElInput, {
                    modelValue: _ctx.form.iconUrl,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.iconUrl) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["error"]),
              _createVNode(_component_ElFormItem, { class: "text-center -mx-2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ElButton, {
                    type: "primary",
                    class: "mx-1",
                    "native-type": "submit"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Сохранить")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_InertiaLink, {
                    href: '/admin/dynamic_services',
                    class: "inline-block mx-1"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ElButton, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Отменить")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onSubmit"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}